class Customer.ResponseTemplateEditorView extends Backbone.View
  template: JST["backbone/templates/customer/ticket/response_template/editor"]

  blank_model: Backbone.Model.extend({})

  events:
    'click #add_response': '_addResponse'
    'focus #title-box': 'collapseAllContainers'

  modal:
    title: 'Edit template',
    buttons: [
      {
        title: 'Save template',
        event: 'save'
      },
      {
        title: 'Cancel',
        event: 'exit'
      },
    ]

  initialize: (@options = {}) ->
    @isNew = @options.new
    @context = @options.context || new Customer.ResponseTemplateContext()
    @model = @options.model
    @initial_state = _.extend({}, @model.attributes)
    @collection = @options.collection || @model.collection
    @modal.title = @_translatedTitle()
    @modal.buttons[0].title = I18n.t('monitoring.user_settings.predefined_templates.save')
    @modal.buttons[1].title = I18n.t('monitoring.user_settings.predefined_templates.cancel')
    @createModal = !@options.modalView
    @possibleLabels = @options.labels || []
    @responseItemViews = []
    @render()
    @modalInitialize()
    @updatePublicToPrivateVisibility()
    @listenTo @TypesView, 'change', @updatePublicToPrivateVisibility
    setTimeout =>
      @afterRender()
    , 250

  render: ->
    @responseItemCounter = 0
    @$el.html(@template({self: @}))
    @activeButton = @$el.find('#active-button')
    @titleBox = @$el.find('#title-box')
    @activeButton.bootstrapToggle({width: 80, height: 20})
    @_addTags()
    @_addTypes()
    @_addLabels()
    @_renderGroupsFilter()
    @_renderTagsFilter()
    if @isNew
      @_addResponse()
    else
      @model.get('templates').map (response) => @_addResponse(text: response)
    @

  afterRender: ->
    @showExpandCollapse(@TagsView)
    @showExpandCollapse(@LabelsView)
    @showExpandCollapse(@TypesView)

  updatePublicToPrivateVisibility: =>
    validTypesName = @typeNames(Keepcon.validTypesForPrivateReply)
    invalidTypes = _.difference @TypesView.toDescriptionArray(), validTypesName
    @automaticSettings?.togglePublicToPrivateVisibility _.isEmpty(invalidTypes)

  modalInitialize: () ->
    if @createModal
      @modalView = new App.ModalView({instance: @, wide: true})
      @modalTab = @modalView.firstTab
      if (@context.isAccount())
        @automaticSettings = new Customer.ResponseTemplateAutomaticSettingsView({collection: @collection, model: @model, editor: @})
        @automaticSettings.modalTab = @modalView.add(@automaticSettings)
    else
      @modalTab = @options.modalView.add(@, true)

  exit: =>
    @model.set(@initial_state)
    @modalTab.removeModal()

  save: =>
    if @validate()
      @saveToServer()

  validate: =>
    validates = true
    if @_onlyForChatbotAssignation() && !@_hasAtLeastOneFilterSelected()
      validates = false
      swal(I18n.t('monitoring.user_settings.predefined_templates.error.at_least_one_selected'))
      return validates
    if !@_onlyForChatbotAssignation() && @_isAutomaticResponse() && !@_hasAtLeastOneTagSelected()
      validates = false
      swal(I18n.t('monitoring.user_settings.predefined_templates.error.at_least_one_tag_selected'))
      return validates

    blankTitle = _.string.isBlank(@titleBox.val())
    @titleBox.toggleClass('error', blankTitle)
    validates = false if blankTitle

    @responseItemViews.forEach (view) =>
      if view.isEmpty() && !@_onlyForChatbotAssignation()
        view.toggleError(true)
        validates = false
      else
        view.toggleError(false)

    if validates
      @responseItemViews.forEach((view) -> view.toggleError(false))
      @titleBox.removeClass('error')

    return validates

  activate: =>
    @modalTab._activate()

  saveToServer: ->
    @model.set(@_serialize())
    $.post('/keepcon/settings/user_setting/response_templates', @model.toJSON())
      .done((response) =>
        @model.set(response.model)
        @updateModel(@model)
        @_recreateTab() if !@automaticSettings
        @modalTab.removeModal())
      .fail((response) =>
        @model.set(@initial_state)
      )

  _onlyForChatbotAssignation: ->
    if @automaticSettings
      @automaticSettings.onlyForChatbotAssignation.prop('checked')

  _isAutomaticResponse: ->
    if @automaticSettings
      @automaticSettings.automaticButton.prop('checked')

  _hasAtLeastOneTagSelected: ->
    @intelligentTagsFilterView.hasSelectedTags()

  _hasAtLeastOneTypeSelected: ->
    @TypesView.toArray().length > 0

  _hasAtLeastOneGroupSelected: ->
    @intelligentGroupsFilterView.hasSelectedGroups()

  _hasAtLeastOneFilterSelected: ->
    (@_hasAtLeastOneTagSelected() || @_hasAtLeastOneTypeSelected() || @_hasAtLeastOneGroupSelected())

  _recreateTab: ->
    @modalTab.remove()
    if @options.modalView
      new Customer.ResponseTemplateEditorView collection: @options.collection, model: new @options.collection.model(),modalView: @options.modalView, new: true
      @options.modalView.firstTab._activate()

  updateModel: (model) =>
    if @isNew
      @collection.add(@expandModel(model))
    @trigger('updateList')
    @collection

  expandModel: (model) =>
    _models = []
    _.each model.get('templates'), (_template) =>
      _models.push new Customer.ResponseTemplate(_.extend(model.attributes, {template: _template} ))
    _models

  _addTags: ->
    @TagsView = new App.AttributesSelectView(
      fixedOptions: @deletedTags()
      attributeOptions: @model.attributes.template_tags_attributes || []
      attributeValueProperty: 'tag'
      options: @collection.possibleTags
      valueProperty: 'code'
      descriptionProperty: 'description'
      placeholder: I18n.t('monitoring.user_settings.predefined_templates.add_a_tag')
      width: "100%"
    )
    @intelligentTagsFilterView = new Customer.ResponseTemplateTagsFilterView
      filter: @model.attributes.intelligent_filter.intelligent_tags
      possibleTags: @collection.possibleTags
      hiddenTags: @collection.hiddenTags
    @TagsView.on('change', => @showExpandCollapse(@TagsView))
    @TagsView.on('showmore', => @expandContainer(@TagsView, '#tags') )
    @TagsView.on('showless', => @collapseContainer(@TagsView, '#tags') )
    @$el.find('#tags').append(@TagsView.el)

  _addLabels: ->
    included_labels = _.each(@collection.labels, (x) =>
      _.find(@label_id, {id: x.label_id} )
    , @model.attributes.template_labels_attributes
    )
    @intelligentGroupsFilterView = new Customer.ResponseTemplateGroupsFilterView(
      filter: @model.attributes.intelligent_filter
      groups: @collection.groups
    )
    @LabelsView = new App.AttributesSelectView(
      attributeOptions: @model.attributes.template_labels_attributes
      attributeValueProperty: 'label_id'
      options: @collection.labels
      valueProperty: 'id'
      descriptionProperty: 'name'
      placeholder: I18n.t('monitoring.user_settings.predefined_templates.add_a_group')
      width: "100%"
    )
    @LabelsView.on('change', => @showExpandCollapse(@LabelsView))
    @LabelsView.on('showmore', => @expandContainer(@LabelsView, '#labels') )
    @LabelsView.on('showless', => @collapseContainer(@LabelsView, '#labels') )
    @$el.find('#labels').append(@LabelsView.el)
    if @possibleLabels.length > 0
      _.each @possibleLabels, (name) =>
        @LabelsView.selectByText(name)

  _addTypes: ->
    types = @collection.filtered_types
    [lonely, otherTypes] = _.partition(types, (type) -> type.name is 'email')
    lonely = @translate(lonely)[0]

    selectViewKlass = if lonely then App.LonelyOptionSelectView else App.AllSelectView
    @TypesView = new selectViewKlass(
      selectedOptions: @model.attributes.template_types || []
      options: @translate(otherTypes)
      lonely: lonely
      valueProperty: 'id'
      descriptionProperty: 'name'
      placeholder: I18n.t('monitoring.user_settings.predefined_templates.type.add_a_type')
      width: "50%"
    )
    @listenTo(@TypesView, 'selection:lonely:error', @_emailTypeSelectionError)
    @listenTo(@TypesView, 'change', @_toggleHTMLMode)
    @TypesView.on('change', => @showExpandCollapse(@TypesView))
    @TypesView.on('showmore', => @expandContainer(@TypesView, '#types'))
    @TypesView.on('showless', => @collapseContainer(@TypesView, '#types'))
    @$el.find('#types').append(@TypesView.el)

  _emailTypeSelectionError: ->
    swal
      title: I18n.t('monitoring.user_settings.signatures.type_error.title'),
      text: I18n.t('monitoring.user_settings.signatures.type_error.text'),
      type: 'info',
      showCancelButton: false,
      confirmButtonClass: 'btn-info',
      confirmButtonText: 'Ok',
      closeOnConfirm: true

  _toggleHTMLMode: =>
    @responseItemViews.forEach((view) => view.toggleMode(@_getEditorMode()))

  _getEditorMode: =>
    return 'html' if @_translateName('email') in @TypesView.toDescriptionArray()
    'plain'

  _addResponse: (options) =>
    text = options?.text
    @responseItemCounter += 1
    responseItemView = new Customer.ResponseTemplateItemView(
      responseItemCounter: @responseItemCounter
    )
    @listenTo(responseItemView, 'focus', @collapseAllContainers)
    @responseItemViews.push(responseItemView)
    @$el.find('.responses_container').append(responseItemView.render(
      text: text
      mode: @_getEditorMode()
    ).el)
    @listenTo(responseItemView, 'destroy', @destroyItemView)
    responseItemView.focus()
    responseItemView

  destroyItemView: (responseItemView) ->
    responseItemView.remove()
    @responseItemViews = _.without(@responseItemViews, responseItemView)

  _serialize: ->
    results =
      title: @titleBox.val()
      active: @activeButton.prop('checked')
      templates: _.map(@responseItemViews, (view) -> view.getText())
      template_type: @_getEditorMode()
      context: @context.toS()

    results.assign_to_operator_id = -1 if !@_onlyForChatbotAssignation()

    results.template_type_ids = @TypesView.toArray()
    results.template_tags_attributes = @TagsView.allAttributes()
    results.template_labels_attributes = @LabelsView.allAttributes()
    results.intelligent_filter =
      intelligent_groups: @intelligentGroupsFilterView.getIntelligentGroups()
      intelligent_tags: @intelligentTagsFilterView.getIntelligentTags()

    if @automaticSettings
      results.automatic = @automaticSettings.automaticButton.prop('checked')
      results.use_work_calendar = @automaticSettings.automaticResponse.prop('checked')
      results.priority = parseInt(@automaticSettings.automaticPriority.val())
      results.private_reply_for_public_contents = @automaticSettings.publicToPrivate()
      results.conversation_status_after_response = @automaticSettings.ticketStatusAfterResponse.val()
      if @automaticSettings.onlyForChatbotAssignation.prop('checked')
        results.assign_to_operator_id = 0
        if @automaticSettings.chatbotCode.val()
          results.chatbot_code = @automaticSettings.chatbotCode.val().trim()
        else
          swal('Please select a valid Bot Id')
          throw new Error('chatbotCode does not have a value')
      else
        results.assign_to_operator_id = -1
    results

  _translatedTitle: ->
    if @isNew
      I18n.t('monitoring.user_settings.predefined_templates.new')
    else
      I18n.t('monitoring.user_settings.predefined_templates.edit')

  deletedTags: ->
    tags = _.select(@model.attributes.template_tags_attributes, (tag) =>
      !_.some(@collection.possibleTags, (possibleTag) -> possibleTag.code == tag.tag)
    )
    _.collect(tags, 'tag')

  collapseContainer: (view, container) ->
    setTimeout =>
      @$el.find(container).removeClass('chosen-expanded')
      @$el.find(container).animate({'max-height':"101px"}, 100)
      view.$el.find('.showless').css('display','none')
      @showExpandCollapse view
    ,100
    false

  collapseAllContainers: ->
    _.each ['tags','types','labels'], (target, counter) =>
      @$el.find('#' + target).removeClass('chosen-expanded')
      @$el.find('#' + target).animate({'max-height':"101px"}, 100)
      @$el.find('.showless').css('display','none')
    @showExpandCollapse @TagsView
    @showExpandCollapse @TypesView
    @showExpandCollapse @LabelsView
    false

  expandContainer: (_target, container) ->
    _target.$el.find('.showmore').css('display','none')
    _target.$el.find('.showless').css('display','block')
    @$el.find(container).removeClass('chosen-collapse')
    @$el.find(container).addClass('chosen-expanded')

  showExpandCollapse: (_view) ->
    if _view.$el.find('.tags')[0].scrollHeight > _view.$el.find('.tags')[0].clientHeight
      _view.$el.find('.showmore').css('display','block')
    else
      _view.$el.find('.showmore').css('display','none')

  translate: (types) ->
    _.map types, (subType) =>
      name: @_translateName(subType.name)
      id: subType.id

  _translateName: (name) ->
    I18n.t("monitoring.arrival_alerts.subtypes.#{name}")

  typeNames: (types)->
    types.map (sub_type) -> I18n.t('monitoring.arrival_alerts.subtypes.' + sub_type)

  _renderGroupsFilter: ->
    @$('.groups-filter-container').html(@intelligentGroupsFilterView.render().el)

  _renderTagsFilter: ->
    @$('.tags-filter-container').html(@intelligentTagsFilterView.render().el)
